<template>
	<!--首页-->
	<div class="app">
		<!--头部-->
		<navHeader></navHeader>
		
		<div class="container"  ref="element" style="margin-top: 100px;text-align: center;">
			<div class="tit">{{list.tit}}</div>
			<div class="day">添加时间：{{list.y}}年{{list.day}}</div>
			<div class="txt">{{list.txt}}</div>
			<div class="img" v-for="(item,index) in list.imgBg">
				<img class="img-fluid"  style="width: 100%;" :src="item.img"/> 
			</div>
		</div>
		 
		<!--底部--> 	
		<comFooter></comFooter>
	</div>
</template>
<script>
	import navHeader from '@/components/navHeader/index.vue'
	import comFooter from '@/components/comFooter/index.vue'
	export default {
		components: {
			navHeader,
			comFooter
		},
		data() {
			return {
			    list:{},
			}
		},
		created() {
		},
		mounted() {
			let that = this  
			that.list = JSON.parse(this.$route.query.list)
			console.log(that.list)
		},
		methods: {
		},
	}
</script>
<style scoped lang="less">
   @w: 19.2vw;
	.tit{
		font-size: 22/@w;
		color: #166BAB;
	}
	.day{
		font-size: 22/@w;
		color: #616161;
		padding: 30/@w 0;
	}
	.txt{
		font-size: 18/@w;
		color: #9B9B9B;
		padding-bottom: 30/@w;
	}
	.img{
		margin-bottom:30/@w ;
	}
</style>


// WEBPACK FOOTER //
// src/pages/newsDetail/index.vue